<template>
  <app-layout>
    <template #header>
      <AppHead :title="getTitle" />
      <h2 class="title">
        Payment Settings for <span v-if="user.first_name">Customer {{ user.first_name }} {{ user.last_name }}</span> <span v-else>Guest</span>
      </h2>
      <flash-messages />
    </template>

    <section class="card mt-3">
      <card title="Payment Settings">
        <div class="mb-2 d-flex flex-column flex-lg-row align-items-start pl-3">
          <p v-if="user.email" class="mb-2 text-secondary mr-3">
            <i class="fas fa-envelope"></i> <Email v-model="user.email" />
          </p>
          <p v-if="user.phone_number" class="mb-2 text-secondary">
            <i class="fas fa-phone-alt"></i> <Phone v-model="user.phone_number" />
          </p>
        </div>
        <div class="row">
          <div class="col-12 col-lg-6">
            <div class="form-group" v-if="can_edit_starting_account_balance">
              <jet-label for="starting_account_balance" value="Starting Account Balance" />
              <AmountInput inputId="starting_account_balance" v-model="form.starting_account_balance" bottom-margin="mb-2" />
              <jet-input-error :message="form.errors.starting_account_balance" class="mt-2" />
              <p class="mb-3 text-size-small text-secondary">Set a starting account balance for this customer. Once a payment has been made towards this amount, it can no longer be changed.</p>
            </div>
            <p class="mb-3 text-size-small text-secondary" v-else>Starting account balance: {{ formatDollars(form.starting_account_balance) }} - Cannot edit, payment has been made against this amount.</p>

            <div>
              <jet-label for="payment_minimum" value="Minimum Payment" />
              <AmountInput inputId="payment_minimum" v-model="form.payment_minimum" bottomMargin="mb-1" />
              <jet-input-error :message="form.errors.payment_minimum" class="mt-2" />
              <p class="text-secondary text-size-small">Current Account Balance: {{ (balance < 0 ? '-$' : '$') + formatCurrency(Math.abs(balance)) }}</p>
            </div>
          </div>

          <div class="form-group col-12 col-lg-6">
            <jet-label for="day-of-week">Payment Day of Week</jet-label>
            <select id="day-of-week" v-model="form.payment_day_of_week" class="form-control">
              <option disabled value="-1">Select Day</option>
              <option v-for="(day, index) in days" :key="index" :value="index">{{ day }}</option>
            </select>
            <div v-if="user.location && user.location.location_visit_on_day !== null">
              Visiting Location on {{ moment().day(user.location.location_visit_on_day).format('dddd') }}
            </div>
          </div>
        </div>

        <jet-button class="card-button" btnStyle="dark" icon="fas fa-save" @click="saveCredit()">Save</jet-button>
      </card>

    </section>
  </app-layout>
</template>

<script>
  import AppLayout from '@/Layouts/AppLayout'
  import FlashMessages from '@/Shared/FlashMessages'
  import Icon from '@/Shared/Icon'

  import JetInput from '@/Jetstream/Input'
  import JetCheckbox from '@/Jetstream/Checkbox'
  import JetInputError from '@/Jetstream/InputError'
  import JetLabel from '@/Jetstream/Label'
  import AmountInput from '@/Shared/AmountInput'

  import moment from 'moment'

  export default {
    components: {
      AppLayout,
      FlashMessages,
      Icon,
      JetInput,
      JetCheckbox,
      JetInputError,
      AmountInput,
      JetLabel,
    },
    props: {
      user: Object,
      balance: Number,
      starting_account_balance: Number,
      can_edit_starting_account_balance: Boolean
    },
    data() {
      let days = [];
      let date = null;
      for (var i=0; i<7; i++) {
        date = moment().day(i);
        days[i] = date.format('dddd')
      }

      return {
        days: days,
        form: this.$inertia.form({
          weeks: null,
          down_payment_percent: null,
          requires_approval: 1,
          
          amount: 0,

          credit_max: this.user.credit_max,
          credit_weekly_max: this.user.credit_weekly_max,
          payment_minimum: this.user.payment_minimum,
          payment_day_of_week: this.user.payment_day_of_week || -1,
          available_credit: this.user.available_credit,
          starting_account_balance: this.starting_account_balance
      }),
      }
    },
    created() {
      this.moment = moment;
    },
    computed: {
      getTitle() {
        const name = this.user.first_name ? this.user.first_name + ' ' + this.user.last_name : 'Guest'
        return `Payment Settings for ${name}`
      }
    },
    methods: {
      saveCredit() {
        this.form.post(this.route('user.saveCredit', this.user));
      },
    },
  }
</script>